/**
 * Classification Service - Classificação automática de áreas jurídicas
 */
import { APP_CONFIG } from '@config/constants'

const AREA_ALIASES = {
  civil: 'civel',
  civel: 'civel',
  trabalhista: 'trabalhista',
  trabalho: 'trabalhista',
  criminal: 'criminal',
  penal: 'criminal',
  familia: 'familia',
  familiar: 'familia',
  tributario: 'tributario',
  fiscal: 'tributario',
  administrativo: 'administrativo',
  consumidor: 'consumidor',
  consumerista: 'consumidor',
  outros: 'outros',
  outro: 'outros',
}

function normalizeText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

const ClassificationService = {
  padroes: {
    trabalhista: ['trabalhista', 'trab', 'clt', 'justiça do trabalho', 'trt', 'empregado', 'empregador', 'fgts', 'salário'],
    criminal: ['criminal', 'crime', 'inquérito', 'denúncia', 'réu', 'flagrante', 'prisão', 'homicídio', 'furto', 'roubo'],
    familia: ['família', 'familia', 'divórcio', 'separação', 'guarda', 'alimentos', 'pensão', 'adoção', 'filiação'],
    tributario: ['tributário', 'tributario', 'fazenda', 'receita federal', 'icms', 'ipi', 'pis', 'cofins', 'fiscal'],
    consumidor: ['consumidor', 'cdc', 'procon', 'fornecedor', 'consumo', 'garantia', 'vício'],
    administrativo: ['administrativo', 'licitação', 'improbidade', 'concessão', 'prefeitura', 'governo'],
    civel: ['cível', 'civel', 'indenização', 'contrato', 'obrigação', 'pagamento', 'dívida', 'empréstimo'],
  },

  classificarArea(numeroProcesso, descricao = '') {
    if (!numeroProcesso) return 'outros'
    const numero = (numeroProcesso || '').toLowerCase()
    const desc = (descricao || '').toLowerCase()

    for (const [area, keywords] of Object.entries(this.padroes)) {
      for (const kw of keywords) {
        if (numero.includes(kw) || desc.includes(kw)) return area
      }
    }

    if (numero.includes('trt') || numero.includes('.202')) return 'trabalhista'
    if (numero.includes('.8.13.') || numero.includes('.8.16.') || desc.includes('ação')) return 'civel'

    return 'outros'
  },

  normalizeAreaKey(area) {
    const normalized = normalizeText(area)
      .replace(/^direito\s+/, '')
      .replace(/[^a-z]/g, '')
    if (AREA_ALIASES[normalized]) return AREA_ALIASES[normalized]
    const alias = Object.keys(AREA_ALIASES)
      .filter((candidate) => candidate !== 'outro' && candidate !== 'outros')
      .find((candidate) => normalized.includes(candidate))
    return alias ? AREA_ALIASES[alias] : 'outros'
  },

  resolveArea(prazo) {
    if (prazo?.area && String(prazo.area).trim()) return this.normalizeAreaKey(prazo.area)
    return this.classificarArea(prazo?.numeroProcesso || prazo?.processo, prazo?.descricao || prazo?.titulo)
  },

  getAreaName(area) {
    return APP_CONFIG.AREAS[this.normalizeAreaKey(area)] || 'Outros'
  },

  getAreaColor(area) {
    return APP_CONFIG.AREA_COLORS[this.normalizeAreaKey(area)] || '#95a5a6'
  },
}

export default ClassificationService
